/**
 * @author PengWen
 * @description zoneCode管理
 * @Date 2022/10/21
 */
 import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";

import { component_tool, framework_tool } from '../../../tool';
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizBrowserExport } = component_tool;


class RequirementPartTimePositionManager extends WizContainer {
  componentName = 'requirementPartTimePositionManager';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key){
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        delete: this._handleCMD,
        enable: this._handleCMD,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(RequirementPartTimePositionManager);